import { Component, ViewEncapsulation, HostBinding } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../animations/page-transitions';
import { LocationService } from '../../services/location.service';

@Component({
	selector: 'copo-not-found',
	templateUrl: './notfound.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, MatButtonModule]
})
export class NotFoundComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;
	constructor(readonly locationService: LocationService) {}
}
